import DisplayObject = createjs.DisplayObject;
import { ColorTransform } from "./ColorTransform";

export class Transform {

    private _colorTransform: ColorTransform;
    private _displayObject: DisplayObject;

    public constructor(disp: DisplayObject) {
        this._colorTransform = new ColorTransform();
        this._colorTransform.displayObject = disp;
        this._displayObject = disp;
    }

    public set colorTransform(value: ColorTransform) {
        // set the new ColorTransform
        this._colorTransform = value;
        // update the new ColorTransform's displayObject
        this._colorTransform.displayObject = this._displayObject;
        // update the color on the displayObject with the new values
        this._colorTransform.updateColor();

        this._displayObject.doCache();
    }

    public get colorTransform(): ColorTransform { return this._colorTransform; }
}
